import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DownloadManagerService } from 'src/app/servicios/download-manager/download-manager.service';
import { MessageService } from 'src/app/servicios/message/message.service';

@Component({
  selector: 'app-floating-download-indicator',
  templateUrl: './floating-download-indicator.component.html',
  styleUrls: ['./floating-download-indicator.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class FloatingDownloadIndicatorComponent implements OnInit, OnDestroy {
  private dm = inject(DownloadManagerService);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  progress = 0;
  active = false;
  batchInfo: { count: number; sizeFormatted: string; rawSize: number } | null = null;

  private subs: Subscription[] = [];

  ngOnInit() {
    this.subs.push(this.dm.progress$.subscribe((v) => (this.progress = v)));
    this.subs.push(this.dm.active$.subscribe((a) => (this.active = a)));
    this.subs.push(this.dm.batchInfo$.subscribe((b) => (this.batchInfo = b)));
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  /**
   * Maneja el click en el indicador flotante de descargas
   * @returns
   */
  async onClick() {
    if (!this.batchInfo) return;
    const translations = (window as any).translations ?? {};

    const html = `
    <div id="batch-dialog">
      <p id="batch-main">${translations.a_continuacion_descargar ?? 'Descargando'} <b id="batch-current-file-name">${this.batchInfo.count > 0 ? '...' : ''}</b></p>
      <p>${translations.archivo ?? 'Archivo'} <span id="batch-current-index">0</span> / <span id="batch-total">${this.batchInfo.count}</span></p>
      <p><b id="batch-current-percent">0%</b></p>
      <div style="margin-top:8px;"><small id="batch-time-remaining"></small></div>
    </div>
  `;

    const dialogPromise = this.messageService.dialogMessage('info', html, {
      confirmButtonText: translations.aceptar ?? this.translateService.instant('aceptar'),
      showDenyButton: true,
      denyButtonText: translations.cancelar ?? 'Cancelar descarga',
      denyButtonColor: '#d33',
      allowOutsideClick: true,
      allowEscapeKey: true,
      returnFocus: false,
    });

    const subs: Subscription[] = [];
    const updateElements = () => {
      // const nameEl = document.getElementById('batch-current-file-name'); -- nombre del archivo
      const idxEl = document.getElementById('batch-current-index');
      const pctEl = document.getElementById('batch-current-percent');
      const totalEl = document.getElementById('batch-total');

      // const updateName = (v: string | null) => { if (nameEl) nameEl.textContent = v ?? ''; }; -- nombre del archivo
      const updateIdx = (v: number | null) => {
        if (idxEl) idxEl.textContent = v ? String(v) : '0';
      };
      const updatePct = (v: number) => {
        if (pctEl) pctEl.textContent = `${v}%`;
      };
      const updateTotal = (v: number | null) => {
        if (totalEl) totalEl.textContent = v ? String(v) : '0';
      };

      // subs.push(this.dm.currentFileName$.subscribe(v => updateName(v)));  -- nombre del archivo
      subs.push(this.dm.currentIndex$.subscribe((v) => updateIdx(v)));
      subs.push(this.dm.currentFileProgress$.subscribe((v) => updatePct(v)));
      subs.push(this.dm.batchInfo$.subscribe((b) => updateTotal(b?.count ?? 0)));
    };

    updateElements();
    const res = await dialogPromise;
    subs.forEach((s) => s.unsubscribe());

    if (res?.isDenied) {
      // usuario cancela descarga desde el dialogo
      this.dm.cancelBatch();
    }
  }
}
